import api from '../services/api';

export async function downloadInvoicePdf(invoice, prefix = 'invoice') {
  try {
    const response = await api.get(`/admin/billing/invoices/${invoice.id}/pdf/download`, {
      responseType: 'blob',
    });
    const blobUrl = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `${prefix}-${invoice.invoice_number || invoice.id}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    return true;
  } catch (error) {
    console.error('Failed to download invoice PDF:', error);
    return false;
  }
}
